import React, {useState} from 'react';
import './DeleteContactsForm.scss';
import { closeChangeNameContactsForm } from './contactsSlice';
import { updateNameGroupContact } from '../../Authorization/authSlice';

const ChangeNameGroupContactsForm = (props) => {
    const [newGroupName, setNewGroupName] = useState('');
    const { dispatch } = props;
 
         //HANDLE CHANGE NEW NAMEGROUP CONTACT
    const handleChangeNewGroupContact = (event) => {
        const newGroupName = event.target.value;
        setNewGroupName(newGroupName);
    } 
 
 
    // CLICK OK
 
 const onSend = () => {
      
    console.log('Start delete contact action');

        const data = {
            nameGroup: newGroupName,
            groupId: props.groupId,
        }

        dispatch(updateNameGroupContact(data));
       
    
       dispatch(closeChangeNameContactsForm());
    }
    

    // CLOSE FORM
    const onClose = () => {
        const { dispatch } = props;
       
    dispatch(closeChangeNameContactsForm());
    

    }


    const render = () => {

       
            return(
                <div className="DeleteContactsForm">
                    
                <p><b>Введите новое имя группы:</b></p>
                <input type="text" placeholder="имя группы" onChange={handleChangeNewGroupContact}/>
                <button onClick={onSend}>Сохранить</button>
                <button onClick={onClose}>Отмена</button>
                </div>
            )
        
   
    }
return render();
}
export default ChangeNameGroupContactsForm;
  